import { SourceIncomeEntity } from '../entities/source-income-entity';

export default class State {
  loaded = false;

  items: Array<SourceIncomeEntity> = [];
}
